import {readMedicationDose} from '../../shared/medicationDose';
const clean = (value = '') => String(value || '').trim();

const doseFields=record=>{const q=readMedicationDose(record);return {dose:q.amount,unit:q.unit,doseText:q.doseText,doseNeedsClarification:q.needsClarification};};
const cloneCanonicalRecord = (record = {}) => ({
  ...record,
  medication: { ...(record.medication || {}), ...doseFields(record.medication || {}) },
  schedule: {
    ...(record.schedule || {}),
    ...(Array.isArray(record.schedule?.times) ? { times: [...record.schedule.times] } : {}),
  },
  effective: { ...(record.effective || {}) },
  ...(record.actionDetails ? { actionDetails: { ...record.actionDetails } } : {}),
  source: { ...(record.source || {}) },
});

const canonicalScheduleType = (entry = {}) => {
  const type = clean(entry.scheduleType).toLowerCase();
  if (type === 'every_x_hours') return 'interval';
  if (type === 'as_needed') return 'as_needed';
  if (type === 'specific_days') return 'weekdays';
  if (type === 'short_course') return 'course';
  if (type === 'occasionally') return 'occasional';
  return type || 'daily';
};

const legacyAction = (entry = {}) => {
  const explicit = clean(entry.medicationPlanAction || entry.planAction);
  if (explicit) return explicit;
  if (entry.isArchived || entry.effectiveTo) return 'discontinue';
  return 'current_plan';
};

export const readCanonicalMedicationRecord = (entry = {}) => {
  if (entry.canonicalMedicationRecord?.schemaVersion === 1) {
    return cloneCanonicalRecord(entry.canonicalMedicationRecord);
  }
  if (entry.schemaVersion === 1 && entry.medication && entry.schedule) {
    return cloneCanonicalRecord(entry);
  }

  const schedules = Array.isArray(entry.schedules) ? entry.schedules : [];
  const firstSchedule = schedules[0] || {};
  const action = legacyAction(entry);
  return {
    schemaVersion: 1,
    recordKind: 'plan',
    action,
    medication: {
      id: clean(entry.id),
      name: clean(entry.name || entry.medicationName),
      genericName: clean(entry.genericName),
      brandName: clean(entry.brandName),
      aliases: Array.isArray(entry.aliases) ? [...entry.aliases] : [],
      ...doseFields({dose:firstSchedule.dose || entry.dose,unit:firstSchedule.unit || entry.unit,doseText:entry.doseText}),
      form: clean(entry.form),
    },
    schedule: {
      type: canonicalScheduleType(entry),
      text: clean(entry.sourceScheduleText || entry.schedule || entry.scheduleText),
      times: schedules.map((schedule) => clean(schedule?.time)).filter(Boolean),
      intervalHours: Number(entry.intervalHours) || null,
      durationDays: Number(entry.durationDays || entry.courseDays) || null,
      selectedDays: Array.isArray(entry.selectedDays) ? [...entry.selectedDays] : [],
    },
    effective: {
      date: clean(entry.effectiveFrom || entry.startDate),
      endDate: clean(entry.effectiveTo || entry.courseEndDate),
      dateText: '',
      certainty: '',
    },
    provider: clean(entry.prescribingDoctor),
    reason: clean(entry.completionReason),
    actionDetails: action === 'complete_course' ? { ...(entry.completedCourse || {}) } : {},
    source: {
      sourceId: clean(entry.sourceId),
      text: clean(entry.sourceText || entry.notes),
    },
  };
};

export const requireCanonicalMedicationAction = (record = {}) => {
  const action = clean(record.action);
  if (!action) throw new Error('Medication action needs review.');
  return action;
};
